import { render, staticRenderFns } from "./PerformanceConceptsEdit.vue?vue&type=template&id=5612154a&"
import script from "./PerformanceConceptsEdit.vue?vue&type=script&lang=js&"
export * from "./PerformanceConceptsEdit.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceConceptsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports